export class RAMError extends Error {
  code: string;
  params: any;

  constructor(code: string, message: string | string[] = '', params: any = {}) {
    if (!Array.isArray(message)) {
      message = [message];
    }

    const [firstMessage] = message;

    super(firstMessage);
    this.code = code;
    this.params = params;
  }
}
